<template>
  <BaseSection :step="step">

    <template #title>Change Reason</template>

    <template #content>
      <v-form>

        <v-row class="narrowInputs">
          <v-col>
            <v-select v-model="reason" :items="getChangeReasons(getCurrentProduct.confirmed_date)" label="Select Change reason" return-object outlined dense hide-details>
              <template #item="{ item, on, attrs }">
                <v-list-item v-bind="attrs" v-on="(!item.permissions||hasUserGotRoles(item.permissions)) && on">
                  <template v-if="!item.permissions">
                    {{ item.text }}
                  </template>

                  <template v-else>
                    <template v-if="hasUserGotRoles(item.permissions)">
                      {{ item.text }}
                    </template>

                    <v-tooltip v-else bottom>
                      <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
                        <div class="flex grey--text" v-bind="attrsTooltip" v-on="onTooltip">
                          <span>{{ item.text }}</span>
                        </div>
                      </template>

                      <span>{{ item.tooltip.permission }}</span>
                    </v-tooltip>
                  </template>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row class="narrowInputs" v-if="!disableContinue">
          <v-col>
            <v-btn color="primary" class="mb-0" @click="submitContinue">Continue</v-btn>
          </v-col>
        </v-row>

      </v-form>
    </template>

  </BaseSection>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import BaseSection from '@/components/Products/ProductTypes/AllProducts/ChangeTariff/Sections/BaseSection';
  
  export default {
    props: {
      step: {
        type: Number,
        default: 0
      },
    },

    components: { BaseSection },

    computed: {
      ...mapGetters('changeTariff',['getChangeReasons','getChangeReason']),
      ...mapGetters('products',['getCurrentProduct']),
      ...mapGetters("globals", ["hasUserGotRoles"]),

      disableContinue(){
        return !this.getChangeReason.value;
      },

      reason: {
        get() { return this.getChangeReason; },

        set(val){
          this.set_section({section:'reason',value:val});
        }
      },
    },

    methods: {
      ...mapMutations('changeTariff',['set_section','set_activeSections','set_stepNext']),

      submitContinue(){
        this.set_stepNext();
      },
    },
  }
</script>

<style lang="scss" scoped></style>
